const currentYear = new Date().getFullYear();

export const institutionPortalExportHeadersMasterList = [
  { label: 'InstitutionID', key: 'id' },
  { label: 'Last Updated', key: 'timeStamp' },
  { label: 'Province', key: 'province' },
  { label: 'ProvinceCD', key: 'provinceCD' },
  { label: 'ECD_Name', key: 'name' },
  { label: 'Emis Number', key: 'emisNumber' },
  { label: 'District', key: 'district' },
  { label: 'Clasification', key: 'classification' },
  { label: 'Service Type', key: 'ecdServiceType' },
  { label: 'newOrRenewal', key: 'newOrRenewal' },

  { label: 'Registration Type', key: 'registrationType' },
  { label: 'PCR Status', key: 'registrationStatus' },
  { label: 'PCR Level', key: 'pcrLevel' },
  { label: 'PCR Certificate Number', key: 'certificateNumber' },
  { label: 'PCR issueDate', key: 'issueDate' },
  { label: 'PCR expiryDate', key: 'expiryDate' },
  { label: 'Prog Level', key: 'progLevel' },
  { label: 'Prog Status', key: 'progStatus' },
  { label: 'Prog issueDate', key: 'progCertificateIssueDate' },
  { label: 'Prog expiryDate', key: 'progCertificateExpiryDate' },
  { label: 'Prog Certificate Number', key: 'progCertificateNumber' },

  { label: 'Land Owner', key: 'ownerLand' },
  { label: 'Building Owner', key: 'ownerBuild' },
  { label: 'GIS_Long', key: 'gisLongitude' },
  { label: 'GIS_Lat', key: 'gisLatitude' },
  { label: 'DMunName', key: 'districtMunicipality' },
  { label: 'LMunName', key: 'localMunicipality' },
  { label: 'Ward_ID', key: 'wardID' },
  { label: 'Addressee', key: 'addressee' },
  { label: 'townshipVillage', key: 'townshipVillage' },
  { label: 'suburb', key: 'suburb' },
  { label: 'townCity', key: 'townCity' },
  { label: 'streetAddress', key: 'streetAddress' },
  { label: 'postalAddress', key: 'postalAddress' },
  { label: 'officeContactNumber', key: 'officeContactNumber' },
  { label: 'feeLevel', key: 'feeLevel' },

  { label: `ECD_Staff_${currentYear}`, key: `numberOfStaff_${currentYear}` },
  { label: `ECD_Staff_${currentYear - 1}`, key: `numberOfStaff_${currentYear - 1}` },
  { label: `ECD_Staff_${currentYear - 2}`, key: `numberOfStaff_${currentYear - 2}` },

  { label: `ECD_Learners_${currentYear}`, key: `numberOfChildrenEnrolled_${currentYear}` },
  { label: `ECD_Learners_${currentYear - 1}`, key: `numberOfChildrenEnrolled_${currentYear - 1}` },
  { label: `ECD_Learners_${currentYear - 2}`, key: `numberOfChildrenEnrolled_${currentYear - 2}` },

  {
    label: `Provincial_Equitable_Share_${currentYear}`,
    key: `fundedThroughEquitableShare_${currentYear}`,
  },
  {
    label: `Provincial_Equitable_Share_${currentYear - 1}`,
    key: `fundedThroughEquitableShare_${currentYear - 1}`,
  },
  {
    label: `Provincial_Equitable_Share_${currentYear - 2}`,
    key: `fundedThroughEquitableShare_${currentYear - 2}`,
  },

  { label: `children_subsidised_ES_${currentYear}`, key: `numberOfChildrenFunded_${currentYear}` },
  {
    label: `children_subsidised_ES_${currentYear - 1}`,
    key: `numberOfChildrenFunded_${currentYear - 1}`,
  },
  {
    label: `children_subsidised_ES_${currentYear - 2}`,
    key: `numberOfChildrenFunded_${currentYear - 2}`,
  },

  {
    label: `Conditional_Grant_Subsidies_${currentYear}`,
    key: `fundedThroughConditionalGrant_${currentYear}`,
  },
  {
    label: `Conditional_Grant_Subsidies_${currentYear - 1}`,
    key: `fundedThroughConditionalGrant_${currentYear - 1}`,
  },
  {
    label: `Conditional_Grant_Subsidies_${currentYear - 2}`,
    key: `fundedThroughConditionalGrant_${currentYear - 2}`,
  },
  { label: `children_subsidised_CG_${currentYear}`, key: `numChildrenSubsidisedCG_${currentYear}` },
  {
    label: `children_subsidised_CG_${currentYear - 1}`,
    key: `numChildrenSubsidisedCG_${currentYear - 1}`,
  },
  {
    label: `children_subsidised_CG_${currentYear - 2}`,
    key: `numChildrenSubsidisedCG_${currentYear - 2}`,
  },
  {
    label: `TopUp_Subsidies_${currentYear}`,
    key: `fundedThroughTopUpSubsidy_${currentYear}`,
  },
  {
    label: `TopUp_Subsidies_${currentYear - 1}`,
    key: `fundedThroughTopUpSubsidy_${currentYear - 1}`,
  },
  {
    label: `TopUp_Subsidies_${currentYear - 2}`,
    key: `fundedThroughTopUpSubsidy_${currentYear - 2}`,
  },
  { label: `children_subsidised_TU_${currentYear}`, key: `numChildrenSubsidisedTU_${currentYear}` },
  {
    label: `children_subsidised_TU_${currentYear - 1}`,
    key: `numChildrenSubsidisedTU_${currentYear - 1}`,
  },
  {
    label: `children_subsidised_TU_${currentYear - 2}`,
    key: `numChildrenSubsidisedTU_${currentYear - 2}`,
  },
  { label: `monthly_TU_subsidy_total_${currentYear}`, key: `monthlyTopUpSubsidyTotal_${currentYear}` },
  {
    label: `monthly_TU_subsidy_total_${currentYear - 1}`,
    key: `monthlyTopUpSubsidyTotal_${currentYear - 1}`,
  },
  {
    label: `monthly_TU_subsidy_total_${currentYear - 2}`,
    key: `monthlyTopUpSubsidyTotal_${currentYear - 2}`,
  },
  {
    label: `infrastructureGrantBudget${currentYear}`,
    key: `infrastructureGrantBudget${currentYear}`,
  },
  {
    label: `infrastructureGrantBudget${currentYear - 1}`,
    key: `infrastructureGrantBudget${currentYear - 1}`,
  },

  {
    label: `infrastructureGrantBudget${currentYear - 2}`,
    key: `infrastructureGrantBudget${currentYear - 2}`,
  },
  {
    label: `monthlyCGBudgetTotal${currentYear}`,
    key: `monthlyCGBudgetTotal${currentYear}`,
  },
  {
    label: `monthlyCGBudgetTotal${currentYear - 1}`,
    key: `monthlyCGBudgetTotal${currentYear - 1}`,
  },
  {
    label: `monthlyCGBudgetTotal${currentYear - 2}`,
    key: `monthlyCGBudgetTotal${currentYear - 2}`,
  },
  {
    label: `monthlyESBudgetTotal${currentYear}`,
    key: `monthlyESBudgetTotal${currentYear}`,
  },
  {
    label: `monthlyESBudgetTotal${currentYear - 1}`,
    key: `monthlyESBudgetTotal${currentYear - 1}`,
  },
  {
    label: `monthlyESBudgetTotal${currentYear - 2}`,
    key: `monthlyESBudgetTotal${currentYear - 2}`,
  },
  {
    label: `registeredCapacity${currentYear}`,
    key: `registeredCapacity${currentYear}`,
  },
  {
    label: `registeredCapacity${currentYear - 1}`,
    key: `registeredCapacity${currentYear - 1}`,
  },
  {
    label: `registeredCapacity${currentYear - 2}`,
    key: `registeredCapacity${currentYear - 2}`,
  },

  {
    label: `Conditional_Grant_Infrastructure_${currentYear}`,
    key: `receivedMaintenanceGrant_${currentYear}`,
  },
  {
    label: `Conditional_Grant_Infrastructure_${currentYear - 1}`,
    key: `receivedMaintenanceGrant_${currentYear - 1}`,
  },
  {
    label: `Conditional_Grant_Infrastructure_${currentYear - 2}`,
    key: `receivedMaintenanceGrant_${currentYear - 2}`,
  },
];

export const institutionPortalExportHeaders = [
  { label: 'InstitutionID', key: 'id' },
  { label: 'name', key: 'name' },
  { label: 'Emis Number', key: 'emisNumber' },
  { label: 'District', key: 'district' },
  { label: 'ecdServiceType', key: 'ecdServiceType' },
  { label: 'registrationType', key: 'registrationType' },
  { label: 'newOrRenewal', key: 'newOrRenewal' },

  { label: 'pcrStatus', key: 'registrationStatus' },
  { label: 'pcrCertificateNumber', key: 'certificateNumber' },
  { label: 'pcrIssueDate', key: 'issueDate' },
  { label: 'pcrExpiryDate', key: 'expiryDate' },
  { label: 'pcrLevel', key: 'pcrLevel' },
  { label: 'progLevel', key: 'progLevel' },
  { label: 'progStatus', key: 'progStatus' },
  { label: 'progIssueDate', key: 'progCertificateIssueDate' },
  { label: 'progExpiryDate', key: 'progCertificateExpiryDate' },
  { label: 'progCertificate Number', key: 'progCertificateNumber' },

  { label: 'organisationName', key: 'organisationName' },
  { label: 'networkName', key: 'networkName' },
  { label: 'privateOrNpo', key: 'privateOrNpo' },
  { label: 'registrationNumber', key: 'registrationNumber' },
  { label: 'npoNumber', key: 'npoNumber' },
  { label: 'building', key: 'building' },
  { label: 'shared', key: 'shared' },
  { label: 'classrooms', key: 'classrooms' },
  { label: 'kitchen', key: 'kitchen' },
  { label: 'space', key: 'space' },
  { label: 'outdoor', key: 'outdoor' },
  { label: 'toilet', key: 'toilet' },
  { label: 'toilets_children', key: 'toilets_children' },
  { label: 'toilets_gender', key: 'toilets_gender' },
  { label: 'capture_toilets_total', key: 'capture_toilets_total' },
  { label: 'count_toilets_children', key: 'count_toilets_children' },
  { label: 'count_toilets_adults', key: 'count_toilets_adults' },
  { label: 'heating', key: 'heating' },
  { label: 'lighting', key: 'lighting' },
  { label: 'cooking', key: 'cooking' },
  { label: 'water', key: 'water' },
  { label: 'waterother', key: 'waterother' },
  { label: 'potable', key: 'potable' },
  { label: 'handwashing', key: 'handwashing' },
  { label: `meals_${currentYear}`, key: `meals_${currentYear}` },
  { label: `meals_${currentYear - 1}`, key: `meals_${currentYear - 1}` },
  { label: `meals_${currentYear - 2}`, key: `meals_${currentYear - 2}` },

  { label: `foodProvider_${currentYear}`, key: `foodProvider_${currentYear}` },
  { label: `foodProvider_${currentYear - 1}`, key: `foodProvider_${currentYear - 1}` },
  { label: `foodProvider_${currentYear - 2}`, key: `foodProvider_${currentYear - 2}` },

  { label: `foodProviderOther_${currentYear}`, key: `foodProviderOther_${currentYear}` },
  { label: `foodProviderOther_${currentYear - 1}`, key: `foodProviderOther_${currentYear - 1}` },
  { label: `foodProviderOther_${currentYear - 2}`, key: `foodProviderOther_${currentYear - 2}` },

  { label: `monthlyFeeRangeLowest_${currentYear}`, key: `monthlyFeeRangeLowest_${currentYear}` },
  { label: `monthlyFeeRangeLowest_${currentYear - 1}`, key: `monthlyFeeRangeLowest_${currentYear - 1}` },
  { label: `monthlyFeeRangeLowest_${currentYear - 2}`, key: `monthlyFeeRangeLowest_${currentYear - 2}` },

  { label: `monthlyFeeRangeHighest_${currentYear}`, key: `monthlyFeeRangeHighest_${currentYear}` },
  {
    label: `monthlyFeeRangeHighest_${currentYear - 1}`,
    key: `monthlyFeeRangeHighest_${currentYear - 1}`,
  },
  {
    label: `monthlyFeeRangeHighest_${currentYear - 2}`,
    key: `monthlyFeeRangeHighest_${currentYear - 2}`,
  },

  { label: `numberOfStaff_${currentYear}`, key: `numberOfStaff_${currentYear}` },
  { label: `numberOfStaff_${currentYear - 1}`, key: `numberOfStaff_${currentYear - 1}` },
  { label: `numberOfStaff_${currentYear - 2}`, key: `numberOfStaff_${currentYear - 2}` },

  { label: `count_staff_male_${currentYear}`, key: `count_staff_male_${currentYear}` },
  { label: `count_staff_male_${currentYear - 1}`, key: `count_staff_male_${currentYear - 1}` },
  { label: `count_staff_male_${currentYear - 2}`, key: `count_staff_male_${currentYear - 2}` },

  { label: `count_staff_female_${currentYear}`, key: `count_staff_female_${currentYear}` },
  { label: `count_staff_female_${currentYear - 1}`, key: `count_staff_female_${currentYear - 1}` },
  { label: `count_staff_female_${currentYear - 2}`, key: `count_staff_female_${currentYear - 2}` },

  { label: 'count_staff_other', key: 'count_staff_other' },
  { label: `count_staff_salary_paid_${currentYear}`, key: `count_staff_salary_paid_${currentYear}` },
  {
    label: `count_staff_salary_paid_${currentYear - 1}`,
    key: `count_staff_salary_paid_${currentYear - 1}`,
  },
  {
    label: `count_staff_salary_paid_${currentYear - 2}`,
    key: `count_staff_salary_paid_${currentYear - 2}`,
  },

  { label: `count_staff_salary_unpaid_${currentYear}`, key: `count_staff_salary_unpaid_${currentYear}` },
  {
    label: `count_staff_salary_unpaid_${currentYear - 1}`,
    key: `count_staff_salary_unpaid_${currentYear - 1}`,
  },
  {
    label: `count_staff_salary_unpaid_${currentYear - 2}`,
    key: `count_staff_salary_unpaid_${currentYear - 2}`,
  },

  { label: 'count_staff_contract_permanent', key: 'count_staff_contract_permanent' },
  { label: 'count_staff_contract_temporary', key: 'count_staff_contract_temporary' },
  { label: 'count_staff_contract_substitute', key: 'count_staff_contract_substitute' },

  { label: `count_staff_time_full_${currentYear}`, key: `count_staff_time_full_${currentYear}` },
  { label: `count_staff_time_full_${currentYear - 1}`, key: `count_staff_time_full_${currentYear - 1}` },
  { label: `count_staff_time_full_${currentYear - 2}`, key: `count_staff_time_full_${currentYear - 2}` },

  { label: `count_staff_time_part_${currentYear}`, key: `count_staff_time_part_${currentYear}` },
  { label: `count_staff_time_part_${currentYear - 1}`, key: `count_staff_time_part_${currentYear - 1}` },
  { label: `count_staff_time_part_${currentYear - 2}`, key: `count_staff_time_part_${currentYear - 2}` },

  { label: `count_staff_cat_educator_${currentYear}`, key: `count_staff_cat_educator_${currentYear}` },
  {
    label: `count_staff_cat_educator_${currentYear - 1}`,
    key: `count_staff_cat_educator_${currentYear - 1}`,
  },
  {
    label: `count_staff_cat_educator_${currentYear - 2}`,
    key: `count_staff_cat_educator_${currentYear - 2}`,
  },

  {
    label: `count_staff_cat_practitioner_${currentYear}`,
    key: `count_staff_cat_practitioner_${currentYear}`,
  },
  {
    label: `count_staff_cat_practitioner_${currentYear - 1}`,
    key: `count_staff_cat_practitioner_${currentYear - 1}`,
  },
  {
    label: `count_staff_cat_practitioner_${currentYear - 2}`,
    key: `count_staff_cat_practitioner_${currentYear - 2}`,
  },
  { label: `count_staff_cat_manager_${currentYear}`, key: `count_staff_cat_manager_${currentYear}` },
  {
    label: `count_staff_cat_manager_${currentYear - 1}`,
    key: `count_staff_cat_manager_${currentYear - 1}`,
  },
  {
    label: `count_staff_cat_manager_${currentYear - 2}`,
    key: `count_staff_cat_manager_${currentYear - 2}`,
  },

  { label: `count_staff_cat_support_${currentYear}`, key: `count_staff_cat_support_${currentYear}` },
  {
    label: `count_staff_cat_support_${currentYear - 1}`,
    key: `count_staff_cat_support_${currentYear - 1}`,
  },
  {
    label: `count_staff_cat_support_${currentYear - 2}`,
    key: `count_staff_cat_support_${currentYear - 2}`,
  },

  { label: 'professionals_practitioners', key: 'professionals_practitioners' },
  { label: `count_staff_qual_skills_${currentYear}`, key: `count_staff_qual_skills_${currentYear}` },
  {
    label: `count_staff_qual_skills_${currentYear - 1}`,
    key: `count_staff_qual_skills_${currentYear - 1}`,
  },
  {
    label: `count_staff_qual_skills_${currentYear - 1}`,
    key: `count_staff_qual_skills_${currentYear - 2}`,
  },

  { label: `count_staff_qual_nqf4_5_${currentYear}`, key: `count_staff_qual_nqf4_5_${currentYear}` },
  {
    label: `count_staff_qual_nqf4_5_${currentYear - 1}`,
    key: `count_staff_qual_nqf4_5_${currentYear - 1}`,
  },
  {
    label: `count_staff_qual_nqf4_5_${currentYear - 2}`,
    key: `count_staff_qual_nqf4_5_${currentYear - 2}`,
  },

  { label: `count_staff_qual_nqf6_9_${currentYear}`, key: `count_staff_qual_nqf6_9_${currentYear}` },
  {
    label: `count_staff_qual_nqf6_9_${currentYear - 1}`,
    key: `count_staff_qual_nqf6_9_${currentYear - 1}`,
  },
  {
    label: `count_staff_qual_nqf6_9_${currentYear - 2}`,
    key: `count_staff_qual_nqf6_9_${currentYear - 2}`,
  },

  { label: `numberOfChildrenEnrolled_${currentYear}`, key: `numberOfChildrenEnrolled_${currentYear}` },
  {
    label: `numberOfChildrenEnrolled_${currentYear - 1}`,
    key: `numberOfChildrenEnrolled_${currentYear - 1}`,
  },
  {
    label: `numberOfChildrenEnrolled_${currentYear - 2}`,
    key: `numberOfChildrenEnrolled_${currentYear - 2}`,
  },

  // { label: `ageRange0To18Months_${currentYear}`, key: `ageRange0To18Months_${currentYear}` },
  // { label: `ageRange0To18Months_${currentYear - 1}`, key: `ageRange0To18Months_${currentYear - 1}` },
  // { label: `ageRange0To18Months_${currentYear - 2}`, key: `ageRange0To18Months_${currentYear - 2}` },

  { label: `ageRange0To12Months_${currentYear}`, key: `ageRange0To12Months_${currentYear}` },
  { label: `ageRange0To12Months_${currentYear - 1}`, key: `ageRange0To12Months_${currentYear - 1}` },
  { label: `ageRange0To12Months_${currentYear - 2}`, key: `ageRange0To12Months_${currentYear - 2}` },

  { label: `ageRange1To2Years_${currentYear}`, key: `ageRange1To2Years_${currentYear}` },
  { label: `ageRange1To2Years_${currentYear - 1}`, key: `ageRange1To2Years_${currentYear - 1}` },
  { label: `ageRange1To2Years_${currentYear - 2}`, key: `ageRange1To2Years_${currentYear - 2}` },

  { label: `ageRange2To3Years_${currentYear}`, key: `ageRange2To3Years_${currentYear}` },
  { label: `ageRange2To3Years_${currentYear - 1}`, key: `ageRange2To3Years_${currentYear - 1}` },
  { label: `ageRange2To3Years_${currentYear - 2}`, key: `ageRange2To3Years_${currentYear - 2}` },

  // { label: `ageRange18MonthsTo3Years_${currentYear}`, key: `ageRange18MonthsTo3Years_${currentYear}` },
  // {
  //   label: `ageRange18MonthsTo3Years_${currentYear - 1}`,
  //   key: `ageRange18MonthsTo3Years_${currentYear - 1}`,
  // },
  // {
  //   label: `ageRange18MonthsTo3Years_${currentYear - 2}`,
  //   key: `ageRange18MonthsTo3Years_${currentYear - 2}`,
  // },

  { label: `ageRange3To4Years_${currentYear}`, key: `ageRange3To4Years_${currentYear}` },
  { label: `ageRange3To4Years_${currentYear - 1}`, key: `ageRange3To4Years_${currentYear - 1}` },
  { label: `ageRange3To4Years_${currentYear - 2}`, key: `ageRange3To4Years_${currentYear - 2}` },

  { label: `ageRange4To5Years_${currentYear}`, key: `ageRange4To5Years_${currentYear}` },
  { label: `ageRange4To5Years_${currentYear - 1}`, key: `ageRange4To5Years_${currentYear - 1}` },
  { label: `ageRange4To5Years_${currentYear - 2}`, key: `ageRange4To5Years_${currentYear - 2}` },

  { label: `ageRange5To6Years_${currentYear}`, key: `ageRange5To6Years_${currentYear}` },
  { label: `ageRange5To6Years_${currentYear - 1}`, key: `ageRange5To6Years_${currentYear - 1}` },
  { label: `ageRange5To6Years_${currentYear - 2}`, key: `ageRange5To6Years_${currentYear - 2}` },

  { label: `gradeROffered_${currentYear}`, key: `gradeROffered_${currentYear}` },
  { label: `gradeROffered_${currentYear - 1}`, key: `gradeROffered_${currentYear - 1}` },
  { label: `gradeROffered_${currentYear - 2}`, key: `gradeROffered_${currentYear - 2}` },

  { label: 'numberOfChildrenFunded', key: 'numberOfChildrenFunded' },
  { label: `funding_${currentYear}`, key: `funding_${currentYear}` },
  { label: `funding_${currentYear - 1}`, key: `funding_${currentYear - 1}` },
  { label: `funding_${currentYear - 2}`, key: `funding_${currentYear - 2}` },

  { label: 'fundingother', key: 'fundingother' },

  { label: `subsidy_${currentYear}`, key: `subsidy_${currentYear}` },
  { label: `subsidy_${currentYear - 1}`, key: `subsidy_${currentYear - 1}` },
  { label: `subsidy_${currentYear - 2}`, key: `subsidy_${currentYear - 2}` },

  { label: 'confirm_subsidy', key: 'confirm_subsidy' },
  {
    label: `fundedThroughEquitableShare_${currentYear}`,
    key: `fundedThroughEquitableShare_${currentYear}`,
  },
  {
    label: `fundedThroughEquitableShare_${currentYear - 1}`,
    key: `fundedThroughEquitableShare_${currentYear - 1}`,
  },
  {
    label: `fundedThroughEquitableShare_${currentYear - 2}`,
    key: `fundedThroughEquitableShare_${currentYear - 2}`,
  },
  {
    label: `fundedThroughConditionalGrant_${currentYear}`,
    key: `fundedThroughConditionalGrant_${currentYear}`,
  },
  {
    label: `fundedThroughConditionalGrant_${currentYear - 1}`,
    key: `fundedThroughConditionalGrant_${currentYear - 1}`,
  },
  {
    label: `fundedThroughConditionalGrant_${currentYear - 2}`,
    key: `fundedThroughConditionalGrant_${currentYear - 2}`,
  },
  {
    label: `fundedThroughTopUpSubsidy_${currentYear}`,
    key: `fundedThroughTopUpSubsidy_${currentYear}`,
  },
  {
    label: `fundedThroughTopUpSubsidy_${currentYear - 1}`,
    key: `fundedThroughTopUpSubsidy_${currentYear - 1}`,
  },
  {
    label: `fundedThroughTopUpSubsidy_${currentYear - 2}`,
    key: `fundedThroughTopUpSubsidy_${currentYear - 2}`,
  },
  {
    label: `assessedForMaintenanceGrant_${currentYear}`,
    key: `assessedForMaintenanceGrant_${currentYear}`,
  },
  {
    label: `assessedForMaintenanceGrant_${currentYear - 1}`,
    key: `assessedForMaintenanceGrant_${currentYear - 1}`,
  },
  {
    label: `assessedForMaintenanceGrant_${currentYear - 2}`,
    key: `assessedForMaintenanceGrant_${currentYear - 2}`,
  },
  { label: `receivedMaintenanceGrant_${currentYear}`, key: `receivedMaintenanceGrant_${currentYear}` },
  {
    label: `receivedMaintenanceGrant_${currentYear - 1}`,
    key: `receivedMaintenanceGrant_${currentYear - 1}`,
  },
  {
    label: `receivedMaintenanceGrant_${currentYear - 2}`,
    key: `receivedMaintenanceGrant_${currentYear - 2}`,
  },
  {
    label: `infrastructureGrantBudget${currentYear - 2}`,
    key: `infrastructureGrantBudget${currentYear - 2}`,
  },
  {
    label: `infrastructureGrantBudget${currentYear - 1}`,
    key: `infrastructureGrantBudget${currentYear - 1}`,
  },
  {
    label: `infrastructureGrantBudget${currentYear}`,
    key: `infrastructureGrantBudget${currentYear}`,
  },
  {
    label: `monthlyCGBudgetTotal${currentYear}`,
    key: `monthlyCGBudgetTotal${currentYear}`,
  },
  {
    label: `monthlyCGBudgetTotal${currentYear - 1}`,
    key: `monthlyCGBudgetTotal${currentYear - 1}`,
  },
  {
    label: `monthlyCGBudgetTotal${currentYear - 2}`,
    key: `monthlyCGBudgetTotal${currentYear - 2}`,
  },
  {
    label: `monthlyESBudgetTotal${currentYear}`,
    key: `monthlyESBudgetTotal${currentYear}`,
  },
  {
    label: `monthlyESBudgetTotal${currentYear - 1}`,
    key: `monthlyESBudgetTotal${currentYear - 1}`,
  },
  {
    label: `monthlyESBudgetTotal${currentYear - 2}`,
    key: `monthlyESBudgetTotal${currentYear - 2}`,
  },
  {
    label: `registeredCapacity${currentYear}`,
    key: `registeredCapacity${currentYear}`,
  },
  {
    label: `registeredCapacity${currentYear - 1}`,
    key: `registeredCapacity${currentYear - 1}`,
  },
  {
    label: `registeredCapacity${currentYear - 2}`,
    key: `registeredCapacity${currentYear - 2}`,
  },

  { label: 'yearOfReceipt', key: 'yearOfReceipt' },
  { label: 'ecdEmploymentStimulus', key: 'ecdEmploymentStimulus' },
  { label: 'dateECDESRFReceived', key: 'dateECDESRFReceived' },
  { label: 'country', key: 'country' },
  { label: 'province', key: 'province' },
  { label: 'districtMunicipality', key: 'districtMunicipality' },
  { label: 'localMunicipality', key: 'localMunicipality' },
  { label: 'wardID', key: 'wardID' },
  { label: 'streetAddress', key: 'streetAddress' },
  { label: 'streetNo', key: 'streetNo' },
  { label: 'suburb', key: 'suburb' },
  { label: 'townshipVillage', key: 'townshipVillage' },
  { label: 'townCity', key: 'townCity' },
  { label: 'locality', key: 'locality' },
  { label: 'postalAddress', key: 'postalAddress' },
  { label: 'postalCode', key: 'postalCode' },
  { label: 'gisLatitude', key: 'gisLatitude' },
  { label: 'gisLongitude', key: 'gisLongitude' },
  { label: 'gisSource', key: 'gisSource' },
  { label: 'nearestPointOfInterest', key: 'nearestPointOfInterest' },
  { label: 'pointOfInterest', key: 'pointOfInterest' },
  { label: 'officeEmailAddress', key: 'officeEmailAddress' },
  { label: 'officeContactNumber', key: 'officeContactNumber' },
  { label: 'contactPersonDesignation', key: 'contactPersonDesignation' },
  { label: 'contactPersonFullName', key: 'contactPersonFullName' },
  { label: 'contactPersonContactNumber', key: 'contactPersonContactNumber' },
  { label: 'contactPersonEmail', key: 'contactPersonEmail' },
  { label: 'alternativeContactPersonDesignation', key: 'alternativeContactPersonDesignation' },
  { label: 'alternativeContactPersonFullName', key: 'alternativeContactPersonFullName' },
  { label: 'alternativeContactPersonContactNumber', key: 'alternativeContactPersonContactNumber' },
  { label: 'alternativeContactPersonEmail', key: 'alternativeContactPersonEmail' },
  { label: 'registrationOffice', key: 'registrationOffice' },
  { label: 'identifiedBy', key: 'identifiedBy' },
  { label: 'dateIdentified', key: 'dateIdentified' },
  { label: 'sspSupervisor', key: 'sspSupervisor' },
  { label: 'socialServicesProfessional', key: 'socialServicesProfessional' },
  { label: 'duplicateReference', key: 'duplicateReference' },
  { label: 'duplicateAction', key: 'duplicateAction' },
  { label: 'reasonForDuplicateAction', key: 'reasonForDuplicateAction' },
  { label: 'trackingCode', key: 'trackingCode' },
  { label: 'verified', key: 'verified' },
  { label: 'validated', key: 'validated' },
  { label: 'source', key: 'source' },
  { label: 'censusDate', key: 'censusDate' },
  { label: 'isArchived', key: 'isArchived' },
  { label: 'timeStamp', key: 'timeStamp' },
];
